import { DefaultLayout, PrivateLayout, WebLayout } from "../layouts";
import ResetPassword from "../components/ResetPassword/ResetPassword";
import ChangePasswordForm from "../components/ResetPassword/ChangePasswordForm";
import SignUpUser from "../components/AuthUser/SignUp/SignUpUser";
import LoginForm from "../components/Login/LoginForm";
import ChangePassForm from "../components/ResetPassword/ChangePassForm";

// Route Views
const AuthRoutes = [
  {
    path: "/",
    exact: true,
    layout: PrivateLayout,
    // component: () => <Navigate to="/" />,
    component: LoginForm,
  },

  {
    path: "/forgot-password",
    exact: true,
    layout: PrivateLayout,
    component: ResetPassword,
  },
  {
    path: "/change-password",
    exact: true,
    // layout: DefaultLayout,
    layout: PrivateLayout,
    component: ChangePasswordForm,
  },
  {
    path: "/signup",
    exact: true,
    layout: PrivateLayout,
    component: SignUpUser,
  },

  {
    path: "/password-change",
    exact: true,
    layout: DefaultLayout,
    component: ChangePassForm,
  },
];

export default AuthRoutes;
